import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@design-system/box';
import { s__ } from '@design-system/i18n';
import { Price } from './Price';
export const Total = ({ hasRecurringPayments, items, locale }) => {
    var _a;
    const total = items.reduce((result, { quantity, total: itemPrice }) => result + quantity * itemPrice, 0);
    const currency = (_a = items[0]) === null || _a === void 0 ? void 0 : _a.currency;
    const renderZeroAsFree = items.length === 0 || !currency;
    return (_jsxs(Box, { font: "h4-semibold", children: [_jsx(Price, { currency: currency, dataTestId: "total-amount-label", locale: locale, price: total, renderZeroAsFree: renderZeroAsFree }), hasRecurringPayments ? (_jsxs("span", { children: ["\u00A0", s__('OrderSummary|now')] })) : null] }));
};
//# sourceMappingURL=Total.js.map